// extracted by mini-css-extract-plugin
module.exports = {"containerFullHeight":"Skeleton_containerFullHeight__3_6qf","containerItemsCenter":"Skeleton_containerItemsCenter__2t4vy"};